import { Numeric } from "../../util";
import { EnumerationsLogic, Translations } from "../../logic";
import { CarBenefitUsecase, UserDefinedRow } from "../../model";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";

/**
 * Usecase logic for car benefit rows.
 */
export class CarBenefitUsecaseLogic extends BaseUsecaseLogic {
  /** Gets validation message for BoardUsecaseLogic  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage {
    const data: CarBenefitUsecase = row.data || {};
    if (data.emissionsValue && data.emissionsValue < 0 || data.emissionsValue && data.emissionsValue > 100) {
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.carBenefit.invalidEmissionValues",
      };
    }
    if (!data.kind || !data.ageGroup || (data.isKilometersBased && data.kilometers == null)) {
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.carBenefit.default",
      };
    }
    const msg = EnumerationsLogic.getEnumLabel("CarBenefitCode", data.kind)
      + ", "
      + EnumerationsLogic.getEnumLabel("AgeGroupCode", data.ageGroup)
      + (data.isKilometersBased ? `${Translations.get("SALAXY.VALIDATION.Usecases.carBenefit.kilometerBased")} ${data.kilometers || ""}km` : "")
      + (data.deduction ? `. ${Translations.get("SALAXY.VALIDATION.Usecases.carBenefit.deduction")} ${Numeric.formatPrice(data.deduction)}.` : Translations.get("SALAXY.VALIDATION.Usecases.carBenefit.noDeduction"))
      ;
    return { type: "default", msg };
  }
}
